var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { DEPENDENCY_KEYS, useDependency } from '#context';
export const useGlobalRateLimitMutations = ({ filespaceId, onError, settingName, workspaceId, }) => {
    _react_refresh_temp_1();
    const { handleToasts } = useDependency(DEPENDENCY_KEYS.UseFilespaceSettingsToasts)({
        filespaceId,
        workspaceId,
        settingName,
    });
    const { mutation: { isSuccess, mutate: setGlobalSettings }, } = useDependency(DEPENDENCY_KEYS.UseSetGlobalSettings)({
        filespaceId,
        workspaceId,
        setting: settingName,
    }, {
        onSuccess: () => {
            handleToasts();
        },
        onError,
    });
    const { mutation: { mutate: unsetGlobalSetting }, } = useDependency(DEPENDENCY_KEYS.UseUnsetGlobalSettings)({
        filespaceId,
        workspaceId,
        setting: settingName,
    }, {
        onSuccess: () => {
            handleToasts({ isReset: true });
        },
    });
    const setRateLimit = useCallback((bytesPerSecond) => {
        setGlobalSettings([
            {
                fullName: settingName,
                value: String(bytesPerSecond),
            },
        ]);
    }, [settingName, setGlobalSettings]);
    const unsetRateLimit = useCallback(() => unsetGlobalSetting([settingName]), [settingName, unsetGlobalSetting]);
    return {
        setRateLimit,
        unsetRateLimit,
        isSuccess,
    };
};
_react_refresh_temp_1(useGlobalRateLimitMutations, "jzykvakgMD8hc8aBrz/p+FZpqTQ=", false, () => [useDependency, useDependency, useDependency]);
